import {
  CTF_BASE_SIZE,
  CTF_FLAG_RADIUS
} from 'asteroids-shared/constants'

const BASE_COPY_RADIUS = Math.hypot(CTF_BASE_SIZE, CTF_BASE_SIZE) / 2

export function drawBase(ctx, base, camera) {
  const size = base.size ?? CTF_BASE_SIZE
  camera.forEachVisibleCopy(base.x, base.y, BASE_COPY_RADIUS, (sx, sy) => {
    ctx.save()
    ctx.translate(sx, sy)
    ctx.fillStyle = '#000'
    ctx.strokeStyle = base.color ?? '#fff'
    ctx.lineWidth = 4
    ctx.fillRect(-size / 2, -size / 2, size, size)
    ctx.strokeRect(-size / 2, -size / 2, size, size)
    ctx.restore()
  })
}

export function drawFlag(ctx, flag, camera) {
  camera.forEachVisibleCopy(flag.x, flag.y, CTF_FLAG_RADIUS + 20, (sx, sy) => {
    ctx.save()
    ctx.translate(sx, sy)
    ctx.strokeStyle = '#fff'
    ctx.lineWidth = 2
    ctx.beginPath()
    ctx.moveTo(0, 14)
    ctx.lineTo(0, -18)
    ctx.stroke()

    ctx.fillStyle = '#ff3a3a'
    ctx.beginPath()
    ctx.moveTo(0, -18)
    ctx.lineTo(15, -11)
    ctx.lineTo(0, -4)
    ctx.closePath()
    ctx.fill()
    ctx.restore()
  })
}
